module.exports = __webpack_public_path__ + "assets/img/media_12.ab7ec20c.png";